const menu = {
    list() {
        return [{
            "backMenu": [{
                "child": [{
                    "buttons": ["新增", "查看", "修改", "删除"],
                    "menu": "业主",
                    "menuJump": "列表",
                    "tableName": "yezhuxinxi"
                }],
                "menu": "业主管理"
            }, {
                    "child": [{
                        "buttons": ["新增", "查看", "修改", "删除"],
                        "menu": "住房信息",
                        "menuJump": "列表",
                        "tableName": "loufangxinxi"
                    }],
                    "menu": "住房管理"
                },{
                "child": [{
                    "buttons": ["新增", "查看", "修改", "删除"],
                    "menu": "小区访客",
                    "menuJump": "列表",
                    "tableName": "xiaoqufangke"
                }],
                "menu": "小区访客管理"
            }, {
                "child": [{
                    "buttons": ["新增", "查看", "修改", "删除"],
                    "menu": "社区活动",
                    "menuJump": "列表",
                    "tableName": "shequxinxi"
                }],
                "menu": "社区活动管理"
            },{
                "child": [{
                    "buttons": ["新增", "查看", "修改", "删除"],
                    "menu": "公共设施",
                    "menuJump": "列表",
                    "tableName": "gonggongsheshi"
                }],
                "menu": "公共设施管理"
            },{
                "child": [{
                    "buttons": ["新增", "查看", "修改", "删除"],
                    "menu": "互助需求",
                    "menuJump": "列表",
                    "tableName": "huzhuxuqiu"
                }],
                "menu": "互助需求管理"
            }, {"child":[{"buttons":["查看","处理"],"menu":"报修和投诉","tableName":"messages"}],"menu":"报修和投诉管理"},{
                "child": [{
                    "buttons": ["新增", "查看", "修改", "删除"],
                    "menu": "车位信息",
                    "menuJump": "列表",
                    "tableName": "cheweixinxi"
                }],
                "menu": "车位信息管理"
            },{
                "child": [{
                    "buttons": ["新增", "查看", "修改", "删除"],
                    "menu": "统计分析",
                    "menuJump": "列表",
                    "tableName": "tongji"
                }],
                "menu": "统计分析管理"
            },  {
                "child": [{
                    "buttons": ["查看", "修改"],
                    "menu": "轮播图管理",
                    "tableName": "config"
                }, {
                    "buttons": ["新增", "查看", "修改", "删除"],
                    "menu": "通知公告",
                    "tableName": "news"
                }],
                "menu": "系统管理"
            }],
            "frontMenu": [{
                "child": [{
                    "buttons": ["查看", "预定"],
                    "menu": "车位信息列表",
                    "menuJump": "列表",
                    "tableName": "cheweixinxi"
                }],
                "menu": "车位信息模块"
            }],
            "hasBackLogin": "是",
            "hasBackRegister": "否",
            "hasFrontLogin": "否",
            "hasFrontRegister": "否",
            "roleName": "管理员",
            "tableName": "users"
        },{
            "backMenu": [{
                "child": [{
                    "buttons": ["新增", "查看", "修改", "删除"],
                    "menu": "社区活动",
                    "menuJump": "列表",
                    "tableName": "shequxinxi"
                }],
                "menu": "社区活动管理"
            },{
                "child": [{
                    "buttons": ["新增", "查看", "修改", "删除"],
                    "menu": "互助需求",
                    "menuJump": "列表",
                    "tableName": "huzhuxuqiu"
                }],
                "menu": "互助需求管理"
            }],
            "hasBackLogin": "是",
            "hasBackRegister": "否",
            "hasFrontLogin": "否",
            "hasFrontRegister": "否",
            "roleName": "业主",
            "tableName": "yezhuxinxi"
        }]
    }
}
export default menu;
